const moviePageClasses = {
  container:
    'flex flex-col gap-12 px-8 mb-32 sm:px-16 md:px-32 lg:px-64 mt-16 sm:mt-24 md:mt-32 lg:mt-48 items-center text-lg ',
  imageContainer: 'mx-auto',
  imageFlexContainer:
    'flex flex-col 2xl:flex-row gap-12 sm:w-3/4 md:w-3/4 mx-auto',
  image: 'object-cover h-3/6 w-full',
  title: 'text-4xl font-semibold italic',
  div: 'flex gap-2 text-slate-400',
  plot: 'italic text-xl text-slate-400',
  runtimeContainer: 'gap-2 text-slate-400',
  ratingContainer:
    'flex border border-slate-700 bg-slate-800 rounded p-4 justify-between text-slate-400',
  reviewTitle: 'text-2xl font-semibold mb-2',
  reviewsContainer: 'flex flex-col items-center',
  reviewListContainer:
    'flex flex-col-reverse items-center w-full text-slate-400',
}

export default moviePageClasses
